import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpEvent, HttpHandler, HttpRequest, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import * as constants from '../config/constants';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { NotificationsService } from 'angular2-notifications';

@Injectable()
export class HttpCustomInterceptor implements HttpInterceptor {

    constructor(
        private router: Router,
        private notifications: NotificationsService) {}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        //console.log('Intercepting request:', req.url);
        const isLoginRequest = req.method === 'POST' && req.url.endsWith('/user/session');
        const sessionToken = localStorage.getItem('session_token');
        let headers: HttpHeaders = req.headers.set('Content-Type', 'application/json');
        if (sessionToken && !isLoginRequest) {
            headers = headers.set('X-Dreamfactory-API-Key', constants.SRD_PUBLIC_API_KEY);
            headers = headers.set('x-dreamfactory-session-token', sessionToken);
        }
        const authReq = req.clone({
            headers
        });
        return next.handle(authReq)
        .pipe(
            catchError((error: HttpErrorResponse) => {
              let errorMessage = '';
              if (error.error instanceof ErrorEvent) {
                // Client-side error
                errorMessage = `Error: ${error.error.message}`;
              } else {
                // Server-side error
                errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
                if (error.status === 401 && !isLoginRequest) {
                  errorMessage = 'Sesion expirada, por favor inicie sesión nuevamente.';

                  // Multiple catalog calls can fail at the same time. Only the first
                  // 401 for the current token should clear the session and redirect.
                  if (localStorage.getItem('session_token') === sessionToken) {
                    localStorage.removeItem('session_token');
                    localStorage.removeItem('userProfile');
                    // Wait until the login page (and its notification host) is mounted;
                    // otherwise the route change removes the message immediately.
                    this.router.navigate(['/login']).then(() => {
                      this.notifications.error('Sesión expirada', errorMessage, {
                        timeOut: 5000,
                        showProgressBar: true,
                        pauseOnHover: true,
                        clickToClose: true
                      });
                    });
                  }
                }
              }
              // Handle the error (e.g., log it, display a message, etc.)
              console.error(errorMessage);
              // The login component needs the original HTTP response to display an
              // invalid-credentials message. Existing API consumers expect a string.
              return throwError(isLoginRequest ? error : errorMessage);
            })
          );;


    }
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/srd-proinvel-pipeline/src/app/interceptors/interceptor.ts